/* ml-carousel-v2.js — MiaLyon Review Carousel v3.3 + Ajustement hide */
(function () {
  'use strict';
 
  var FIT_ALLOWED = [
    'raquel-robe-midi-du-quotidien',
    'asta™-robe-midi-du-quotidien',
    'eva-vestido-comodo-dia-a-dia',
    'alberte™-robe-midi-fleurie-classique',
    'esra-abito-da-diario'
  ];
 
  function hideFitBlocks() {
    var pathname = window.location.pathname;
    if (pathname.indexOf('/products/') === -1) return;
    var handle = pathname.split('/products/')[1].split('?')[0].split('/')[0];
    if (FIT_ALLOWED.indexOf(handle) !== -1) return;
    var els = document.querySelectorAll('.ml-fit-widget, .ml-size-guide');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      el.style.setProperty('display', 'none', 'important');
      var block = el.closest('.product-block') || el.closest('[class*="block"]') || el.parentElement;
      if (block && block !== el) { block.style.setProperty('display', 'none', 'important'); }
    }
  }
 
  var style = document.createElement('style');
  style.textContent = [
    '.mlrs-wrap{padding:60px 0 52px!important;overflow:hidden!important;width:100%!important;box-sizing:border-box!important;background:#f8f6f3!important}',
    '.mlrs-header{text-align:center!important;padding:0 24px!important;margin-bottom:44px!important}',
    '.mlrs-title{font-size:clamp(1.5rem,2.8vw,2.2rem)!important;font-weight:700!important;letter-spacing:.04em!important;text-transform:uppercase!important;color:#111!important;margin:0 0 14px!important}',
    '.mlrs-rating-row{display:flex!important;align-items:center!important;justify-content:center!important;gap:10px!important;margin-bottom:6px!important}',
    '.mlrs-rating-label{font-size:20px!important;font-weight:700!important;color:#111!important}',
    '.mlrs-rating-stars{color:#c8952b!important;font-size:22px!important;letter-spacing:-1px!important}',
    '.mlrs-subtitle{font-size:15px!important;color:#999!important;font-style:italic!important;margin:0!important}',
    '.mlrs-outer{position:relative!important;padding:0 64px!important;box-sizing:border-box!important}',
    '#mlrs-track{display:flex!important;gap:20px!important;overflow-x:auto!important;overflow-y:hidden!important;scroll-snap-type:x mandatory!important;scroll-behavior:smooth!important;padding:8px 2px 24px!important;margin:0!important;scrollbar-width:none!important;-ms-overflow-style:none!important;-webkit-overflow-scrolling:touch!important}',
    '#mlrs-track::-webkit-scrollbar{display:none!important}',
    '.mlrs-card{flex:0 0 278px!important;width:278px!important;border-radius:18px!important;overflow:hidden!important;background:#fff!important;box-shadow:0 3px 20px rgba(0,0,0,.09)!important;scroll-snap-align:start!important;transition:transform .28s ease,box-shadow .28s ease!important}',
    '.mlrs-card:hover{transform:translateY(-5px)!important;box-shadow:0 12px 36px rgba(0,0,0,.14)!important}',
    '.mlrs-photo{width:100%!important;height:260px!important;overflow:hidden!important;background:#ece9e4!important;flex-shrink:0!important}',
    '.mlrs-photo img{width:100%!important;height:100%!important;object-fit:cover!important;display:block!important;border-radius:0!important;transition:transform .4s ease!important}',
    '.mlrs-card:hover .mlrs-photo img{transform:scale(1.04)!important}',
    '.mlrs-body{padding:20px 18px 24px!important;background:#fff!important;text-align:center!important;display:flex!important;flex-direction:column!important;align-items:center!important;gap:8px!important}',
    '.mlrs-stars{color:#c8952b!important;font-size:17px!important;letter-spacing:3px!important;line-height:1!important}',
    '.mlrs-text{font-size:13px!important;color:#555!important;line-height:1.6!important;margin:0!important;font-style:italic!important}',
    '.mlrs-author{font-size:12.5px!important;font-weight:700!important;color:#111!important;margin:0!important;letter-spacing:.05em!important;text-transform:uppercase!important}',
    '.mlrs-btn{position:absolute!important;top:50%!important;transform:translateY(calc(-50% - 16px))!important;width:46px!important;height:46px!important;border-radius:50%!important;background:#fff!important;border:1px solid #ddd!important;box-shadow:0 2px 12px rgba(0,0,0,.1)!important;cursor:pointer!important;display:flex!important;align-items:center!important;justify-content:center!important;z-index:10!important;outline:none!important;padding:0!important;color:#111!important;transition:background .2s,border-color .2s,color .2s!important}',
    '.mlrs-btn:hover{background:#111!important;border-color:#111!important;color:#fff!important}',
    '.mlrs-btn svg{width:20px!important;height:20px!important}',
    '.mlrs-btn--prev{left:4px!important}.mlrs-btn--next{right:4px!important}',
    '@media(max-width:900px){.mlrs-outer{padding:0 40px!important}}',
    '@media(max-width:768px){.mlrs-outer{padding:0 16px!important}.mlrs-btn{display:none!important}.mlrs-card{flex:0 0 230px!important;width:230px!important}.mlrs-photo{height:210px!important}}',
    '@media(max-width:480px){.mlrs-card{flex:0 0 200px!important;width:200px!important}.mlrs-photo{height:180px!important}}'
  ].join('');
  document.head.appendChild(style);
 
  var BASE = 'https://cdn.shopify.com/s/files/1/1057/8293/5891/files/';
  var NEW_IMGS = [
    BASE + 'kL9H8.jpg?v=1786051128',
    BASE + '7QMTT.jpg?v=1786051127',
    BASE + 'POf25.jpg?v=1786051127',
    BASE + 'ddHxX.jpg?v=1786051128',
    BASE + 'fOJIa.jpg?v=1786051127',
    BASE + 'oZ4ec.jpg?v=1786051127',
    BASE + 'pS0lr.jpg?v=1786051128',
    BASE + 'skofj.jpg?v=1786051129',
    BASE + 'vHg9V.jpg?v=1786051127',
    BASE + 'fOJIa.jpg?v=1786051127',
    BASE + 'oZ4ec.jpg?v=1786051127',
    BASE + 'kL9H8.jpg?v=1786051128',
    BASE + 'vHg9V.jpg?v=1786051127'
  ];
 
  var POS = [
    'top center','center center','top center','top center','top center',
    'center center','top center','top center','top center','top center',
    'center center','top center','center center'
  ];
 
  var REVIEWS = [
    ['«La robe est magnifique. La coupe est fluide, le tissu est doux et elle met vraiment en valeur.»', 'Julie B.'],
    ['«Le top est joli, léger et de bonne qualité. Il va parfaitement avec un jean ou une jupe.»', 'Sofía M.'],
    ['«Je les ai choisies pour le confort sans renoncer au style. Elles sont devenues mes sandales de tous les jours.»', 'María G.'],
    ['«Le pantalon en lin est léger, fluide et ultra confortable. Parfait pour l’été.»', 'Emma V.'],
    ['«La veste est parfaite, bonne qualité et très confortable. Elle va avec tout et le tombé est superbe.»', 'Isabel M.'],
    ['«Le pantalon en lin est léger, fluide et ultra confortable. Parfait pour l’été, je ne le quitte plus.»', 'Léa T.'],
    ['«Les colis soigneusement emballés m’ont tout de suite rassurée. Ça fait vraiment plus personnel.»', 'Alejandra P.'],
    ['«La robe est magnifique. La coupe est fluide, le tissu est doux et elle met vraiment en valeur.»', 'Julie B.'],
    ['«Le chemisier en lin est léger, élégant et de très bonne qualité. Je l’adore.»', 'Sophie M.'],
    ['«En vrai elle est encore plus belle que sur les photos. La coupe est flatteuse et le tissu est super agréable.»', 'Sabrina G.'],
    ['«Le pantalon en lin est léger, fluide et ultra confortable. Parfait pour l’été, je ne le quitte plus.»', 'Léa T.'],
    ['«La première chose que j’ai remarquée, c’est la beauté des fleurs. Je la porte presque tous les jours, elle reste impeccable.»', 'Rosa L.'],
    ['«Les sandales sont classiques, confortables et sans fioritures. Le service client a rendu l’échange très simple.»', 'Natalia S.']
  ];
 
  function initCarousel() {
    var track = document.getElementById('mlrs-track');
    if (!track || track.querySelector('.mlrs-card')) return;
 
    var sliderOuter = track.closest('.mlrs-slider-outer');
    if (sliderOuter) {
      sliderOuter.parentNode.insertBefore(track, sliderOuter);
      sliderOuter.remove();
    }
 
    Array.from(track.querySelectorAll('.mlrs-slide')).forEach(function (slide, idx) {
      var r = REVIEWS[idx] || ['', ''];
      var newSrc = NEW_IMGS[idx] || '';
      var pos = POS[idx] || 'top center';
 
      slide.className = 'mlrs-card';
      slide.removeAttribute('style');
 
      var photo = document.createElement('div');
      photo.className = 'mlrs-photo';
      var img = document.createElement('img');
      img.src = newSrc;
      img.alt = 'Avis client MiaLyon';
      img.loading = 'lazy';
      img.style.objectPosition = pos;
      photo.appendChild(img);
 
      var body = document.createElement('div');
      body.className = 'mlrs-body';
      body.innerHTML =
        '<div class="mlrs-stars">&#9733;&#9733;&#9733;&#9733;&#9733;</div>'
        + '<p class="mlrs-text">' + r[0] + '</p>'
        + '<p class="mlrs-author">' + r[1] + '</p>';
 
      slide.innerHTML = '';
      slide.appendChild(photo);
      slide.appendChild(body);
    });
 
    var outer = document.createElement('div');
    outer.className = 'mlrs-outer';
    outer.id = 'mlrs-outer';
    track.parentNode.insertBefore(outer, track);
    outer.appendChild(track);
 
    function btn(dir) {
      var b = document.createElement('button');
      b.className = 'mlrs-btn mlrs-btn--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Précédent' : 'Suivant');
      b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="'
        + (dir === 'prev' ? '15 18 9 12 15 6' : '9 18 15 12 9 6') + '"/></svg>';
      b.addEventListener('click', function () {
        var c = track.querySelector('.mlrs-card');
        if (!c) return;
        var g = parseFloat(getComputedStyle(track).gap) || 20;
        track.scrollBy({ left: dir === 'prev' ? -(c.offsetWidth + g) * 3 : (c.offsetWidth + g) * 3, behavior: 'smooth' });
      });
      return b;
    }
    outer.appendChild(btn('prev'));
    outer.appendChild(btn('next'));
 
    function upd() {
      var p = outer.querySelector('.mlrs-btn--prev');
      var n = outer.querySelector('.mlrs-btn--next');
      if (!p || !n) return;
      p.style.opacity = track.scrollLeft < 10 ? '0.35' : '1';
      n.style.opacity = track.scrollLeft + track.clientWidth >= track.scrollWidth - 10 ? '0.35' : '1';
    }
    track.addEventListener('scroll', upd, { passive: true });
    upd();
 
    var sx = 0;
    track.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var d = sx - e.changedTouches[0].clientX;
      if (Math.abs(d) < 40) return;
      var c = track.querySelector('.mlrs-card');
      if (!c) return;
      var g = parseFloat(getComputedStyle(track).gap) || 20;
      track.scrollBy({ left: d > 0 ? c.offsetWidth + g : -(c.offsetWidth + g), behavior: 'smooth' });
    }, { passive: true });
  }
 
  function runAll() {
    hideFitBlocks();
    initCarousel();
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }
})();
 
